// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
// selectors
import { getFooterHTML } from 'shared/store/listingV2/selectors';
import { getSeoFooterContent } from 'shared/store/dynamicPage/selector';

// styles
import { FooterContainer } from './styles';

// helpers
import { useDynamicPage } from 'shared/routes/DynamicPage/helper';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';

function FooterV2() {
  const { isDynamicPageURL } = useDynamicPage();

  const footerHTML = useSelector(getFooterHTML);
  const footerSEOContent = useSelector(getSeoFooterContent);
  const footerHTMLContent = isDynamicPageURL ? footerSEOContent : footerHTML;
  const showListingFooter = get(useRemoteConfig('footerSection'), 'showListingFooter', true);

  if (isEmpty(footerHTMLContent) || !showListingFooter) return null;

  return (
    <FooterContainer
      data-at="listing-footer"
      dangerouslySetInnerHTML={{ __html: sanitizeHTML(footerHTMLContent) }}
    />
  );
}

export default memo(FooterV2);
